var App = App || {};

$(function () {
    var Schedule = function (container) {
        this.container = container;
        this.scheduleWrap = $('.schedule-wrap', this.container);
        this.init();
    };

    Schedule.prototype.init = function () {
        if (this.container.hasClass('loading')) {
            this.load();
        } else {
            this.bind();
        }
    };

    Schedule.prototype.load = function () {
        var scheduleUrl = this.container.data('link');
        if (scheduleUrl) {
            $.get(scheduleUrl, function (data) {
                this.scheduleWrap.html(data);
                this.container.removeClass('loading');
                this.container.fadeTo(0, 0).stop().fadeTo('fast', 1);
                this.form = $('form', this.container);
                this.formDataField = $('#questorderform-data', this.form);
                this.errorsBlock = $('.error-summary', this.form);
                this.modal = $('.modal', this.container);
                this.weeks = this.container.find('.week-block');
                this.currentWeek = this.weeks.filter(':not(.hidden):first');
                this.weekControls = $('.schedule__controls', this.container);
                this.weekNextLink = $('[data-action="next"]', this.weekControls);
                this.weekPrevLink = $('[data-action="prev"]', this.weekControls);
                this.sessionDate = $('.session-time', this.container);
                this.formFieldsWrap = $('.form-fields-wrap', this.container);
                this.successMessage = $('.success-message', this.container);
                this.modalFooter = $('.modal-footer', this.container);
                this.resultPrice = $('.result-price', this.container);
                this.playersField = $('#questorderform-players', this.container);

                if (this.weeks.length > 1) {
                    this.weekControls.removeClass('hidden');
                }
                this.bind();
            }.bind(this));
        }
    };

    Schedule.prototype.bind = function () {
        this.container.on('click', '.schedule__time:not(.booked) button', this.onClick.bind(this));
        this.container.on('onSuccess', this.form, this.onSuccess.bind(this));
        this.container.on('beforeValidate', this.form, this.beforeValidate.bind(this));
        this.container.on('beforeValidateAttribute', this.form, this.beforeValidate.bind(this));
        this.container.on('click', '.schedule__arrow', this.changeWeek.bind(this));
        this.container.on('change', this.playersField, this.onPlayersChange.bind(this))
    };

    Schedule.prototype.onClick = function (event) {
        this.currentSessionBtn = $(event.currentTarget);
        var dateString = this.currentSessionBtn.data('data').date;
        this.sessionDate.text(dateString.replace(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$3.$2.$1 / $4:$5'));

        if (this.container.data('playerslink')) {
            $.get(
                this.container.data('playerslink'), {
                    'date': this.currentSessionBtn.data('date'),
                    'time': this.currentSessionBtn.data('time')

                }, function (data) {
                    if (data) {
                        this.playersField.empty();
                        $.each(data, function (key, value) {
                            this.playersField
                                .append($("<option></option>")
                                    .data('tariff', key)
                                    .data('price', value)
                                    .attr("value", parseInt(key))
                                    .text(key));
                        }.bind(this));
                        this.playersField.children('option:first').prop('selected', true);
                        this.playersField.trigger('change');
                    }

                }.bind(this)
            );
        }

        this.modal.modal('show');
        this.formFieldsWrap.show();
        this.modalFooter.show();
        this.successMessage.addClass('d-none');
        this.errorsBlock.addClass('d-none');
        this.onPlayersChange.call(this);

        if (typeof yaCounter41174354 !== 'undefined') {
            yaCounter41174354.reachGoal('open-order-form', {quest: questData || {}});
        }
    };

    Schedule.prototype.changeWeek = function (event) {
        var link = $(event.currentTarget),
            action = link.data('action'),
            week;

        if (action === 'next') {
            week = this.getNextWeek();
        } else {
            week = this.getPrevWeek();
        }

        if (week.length) {
            var hideWeek = this.currentWeek;
            this.currentWeek = week;

            if (this.getNextWeek().length) {
                this.weekNextLink.removeClass('not-active');
            } else {
                this.weekNextLink.addClass('not-active');
            }

            if (this.getPrevWeek().length) {
                this.weekPrevLink.removeClass('not-active');
            } else {
                this.weekPrevLink.addClass('not-active');
            }

            hideWeek.fadeOut('fast', function () {
                this.currentWeek.removeClass('hidden').fadeIn('fast');
            }.bind(this));

            if (typeof yaCounter41174354 !== 'undefined') {
                yaCounter41174354.reachGoal('change-schedule-week', {quest: questData || {}});
            }
        }
    };

    Schedule.prototype.getPrevWeek = function () {
        return this.currentWeek.prev().filter('.week-block');
    };
    Schedule.prototype.getNextWeek = function () {
        return this.currentWeek.next().filter('.week-block');
    };

    Schedule.prototype.onSuccess = function () {
        this.currentSessionBtn.parent().addClass('booked');
    };

    Schedule.prototype.beforeValidate = function () {
        var extra = $.extend(this.currentSessionBtn.data('data'), {extraData: this.currentSessionBtn.data('extra')});
        this.formDataField.val(JSON.stringify(extra));
    };

    Schedule.prototype.onPlayersChange = function () {
        var params = this.currentSessionBtn.data('params'),
            data = this.currentSessionBtn.data('data'),
            extraData = this.currentSessionBtn.data('extra'),
            price = this.currentSessionBtn.data('originPrice') || data.price,
            priceByPlayer = this.container.data('pricebyplayer'),
            priceData = params['priceByPlayer'] || null,
            selectedOption = this.playersField.children("option:selected"),
            players = parseInt(this.playersField.val()),
            resultPrice = price;

        if (selectedOption.data('tariff')) {
            resultPrice = selectedOption.data('price');
            extraData.tariff = selectedOption.data('tariff');
        } else {
            if (priceByPlayer && !priceData) {
                resultPrice = price * players;
            } else if (priceData && players in priceData) {
                resultPrice = priceData[players];
            }
        }

        this.currentSessionBtn.data('originPrice', price);
        data.price = resultPrice;
        this.currentSessionBtn.data('data', data);
        this.currentSessionBtn.data('extra', extraData);
        this.resultPrice.html(resultPrice + ' &#x20bd;');
    };

    $('.schedule').each(function () {
        new Schedule($(this));
    });
});
